module.exports = __webpack_public_path__ + "static/media/modal_sign_left_k.cc6ab432.png";